// src/services/clientService.js
import { tenantDataService } from './tenantDataService';

const COLLECTION_NAME = 'clients';

class ClientService {
  // Get all clients
  async getAllClients() {
    return await tenantDataService.getAll(COLLECTION_NAME);
  }

  // Get client by ID
  async getClientById(id) {
    return await tenantDataService.getById(COLLECTION_NAME, id);
  }

  // Create new client
  async createClient(clientData) {
    return await tenantDataService.create(COLLECTION_NAME, clientData);
  }

  // Update client
  async updateClient(id, clientData) {
    return await tenantDataService.update(COLLECTION_NAME, id, clientData);
  }

  // Delete client
  async deleteClient(id) {
    return await tenantDataService.delete(COLLECTION_NAME, id);
  }

  // Search clients by name or email
  async searchClients(searchTerm) {
    const allClients = await this.getAllClients();
    return allClients.filter(client => 
      client.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      client.email?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  // Get clients with appointments in date range
  async getClientsWithAppointments(startDate, endDate) {
    // This would need to be implemented with proper joins in Firebase
    // For now, return all clients
    return await this.getAllClients();
  }

  // Subscribe to client changes
  subscribeToClients(callback) {
    return tenantDataService.subscribe(COLLECTION_NAME, callback);
  }

  // Unsubscribe from client changes
  unsubscribeFromClients(listenerId) {
    tenantDataService.unsubscribe(listenerId);
  }

}

const clientService = new ClientService();
export { clientService };
export default clientService;
